import { COUNTRY_CODES, LENGTH_BY_COUNTRY_CODE, LINE, MOBILE } from "./phone.data";

function getLengthInfoByCountryCode(countryCode: string): { min: number; max: number } {
	if (LENGTH_BY_COUNTRY_CODE[countryCode]) {
		const min = LENGTH_BY_COUNTRY_CODE[countryCode][0];
		const max = LENGTH_BY_COUNTRY_CODE[countryCode][1] || LENGTH_BY_COUNTRY_CODE[countryCode][0];

		return { min, max };
	}

	return { min: 0, max: 0 };
}

function splitPhoneNumber(phoneNumber: string): { country: string; prefix: string; other: string[] } {
	let [country, prefix, ...other] = phoneNumber.split(" ");

	if (phoneNumber.length > 5 && !phoneNumber.includes(" ")) {
		country = phoneNumber.substring(0, 3);
		prefix = phoneNumber.substring(3, 5);

		if (prefix.startsWith("1")) {
			prefix = "1";
			const otherStr = phoneNumber.substring(4);
			other = [otherStr.substring(0, 3), otherStr.substring(3)];
		} else {
			const otherStr = phoneNumber.substring(5);
			other = [otherStr.substring(0, 3), otherStr.substring(3)];
		}
	}

	return { country, prefix, other };
}

export function phoneValidator(phoneNumber: string): boolean {
	if (!phoneNumber || typeof phoneNumber !== "string") {
		return false;
	}
	const { country, prefix, other } = splitPhoneNumber(phoneNumber);

	if (
		!country ||
		!prefix ||
		!other ||
		!country.match(/^\+(\d{1,3}|1-?\d{3}|5399)$/) ||
		!prefix.match(/^\d+$/) ||
		!other.join("").match(/^\d+$/) ||
		!COUNTRY_CODES.includes(country.replace("+", ""))
	) {
		return false;
	}

	const { min, max } = getLengthInfoByCountryCode(country.replace("+", ""));
	const { length } = (prefix + other).replace(/\D+/, "");

	if (length < min || length > max) {
		return false;
	}

	if (country === "+36") {
		if (MOBILE.includes(prefix) || prefix === "1") {
			return other.length === 2 && other[0].length === 3 && other[1].length === 4;
		}

		return LINE.includes(prefix) && other.length === 2 && other[0].length === 3 && other[1].length === 3;
	}

	return true;
}

export function phoneFormatter(phoneNumber: string): string {
	if (!phoneNumber) {
		return undefined;
	}

	if (typeof phoneNumber === "number") {
		return phoneFormatter(`${phoneNumber}`);
	}

	let resultNumber = phoneNumber.replace(/[oO]/g, "0").replace(/\D+/g, "");

	if (MOBILE.includes(phoneNumber.substring(0, 2)) && phoneNumber.split(" ").join("").length === 9) {
		resultNumber = `36${resultNumber}`;
	}

	if (resultNumber.startsWith("00")) {
		resultNumber = resultNumber.replace("00", "");
	}

	if (resultNumber.startsWith("06")) {
		resultNumber = resultNumber.replace("06", "36");
	}

	let output = "";

	if (resultNumber.startsWith("1") || resultNumber.startsWith("7")) {
		output = `+${resultNumber[0]}`;

		if (resultNumber.length > 1) {
			output += ` ${resultNumber.substring(1, 4)}`;
		}

		if (resultNumber.length > 4) {
			output += ` ${resultNumber.substring(4, 7)}`;
		}

		if (resultNumber.length > 7) {
			output += ` ${resultNumber.substring(7)}`;
		}

		return output;
	}

	if (resultNumber.startsWith("36")) {
		output = "+36";
		let prefix = "";

		if (resultNumber.length > 2) {
			prefix = resultNumber[2] === "1" ? "1" : resultNumber.substring(2, 4);
			output += ` ${prefix}`;
		}

		if (prefix === "1") {
			if (resultNumber.length > 3) {
				output += ` ${resultNumber.substring(3, 6)}`;
			}

			if (resultNumber.length > 6) {
				output += ` ${resultNumber.substring(6)}`;
			}
		} else {
			if (resultNumber.length > 4) {
				output += ` ${resultNumber.substring(4, 7)}`;
			}

			if (resultNumber.length > 7) {
				output += ` ${resultNumber.substring(7)}`;
			}
		}

		return output;
	}

	if (COUNTRY_CODES.includes(resultNumber.substring(0, 2))) {
		output = `+${resultNumber.substring(0, 2)}`;

		if (resultNumber.length > 2) {
			output += ` ${resultNumber.substring(2, 5)}`;
		}

		if (resultNumber.length > 5) {
			output += ` ${resultNumber.substring(5, 8)}`;
		}

		if (resultNumber.length > 8) {
			output += ` ${resultNumber.substring(8)}`;
		}

		return output;
	}

	output = `+${resultNumber.substring(0, 3)}`;

	if (resultNumber.length > 3) {
		output += ` ${resultNumber.substring(3, 6)}`;
	}

	if (resultNumber.length > 6) {
		output += ` ${resultNumber.substring(6, 9)}`;
	}

	if (resultNumber.length > 9) {
		output += ` ${resultNumber.substring(9)}`;
	}

	return output;
}

export function phoneCleanFormatter(phoneNumber: string): string {
	return (phoneFormatter(phoneNumber) || "").replace(/\s+/g, "");
}
